
import LangCache from '../../base/langCache';
import React , { Fragment  } from 'react';
export interface IProps {
    lang?: string;
    i18nKey?: string;
    children: string;
}

export function PlainText(props: IProps) {
    const LANG = LangCache.getLang();
    const text = LANG[props.i18nKey || props.children || ''];

    return (
        <Fragment>
            {text || props.children}
        </Fragment>
    );
}
